/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import { FaArrowLeftLong, FaArrowRightLong, FaPlay } from "react-icons/fa6";
import Slider from "react-slick";
import { LuCalendar1 } from "react-icons/lu";
import { MdOutlineAccessTime } from "react-icons/md";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { TbTicket, TbUsers } from "react-icons/tb";
import Loading from "../../Loading";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import mappin from "../../Images/map.png";
import mapicon from "../../Icon/map-pin.svg";
import chaticon from '../../Icon/Vector.svg';
import profile from '../../Images/profile-default.png';
import { showTost } from "../../showTost";
import { GoPlus } from "react-icons/go";
import { IoIosRemove } from "react-icons/io";
import Chat from "./Chat";
import { useTranslation } from "react-i18next";
import LightboxImg from "./LightBox";
import { formatMoney, getSiteCurrency } from "../../utils/money";
const NextArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow next" onClick={onClick}>
            <FaArrowRightLong />
        </button>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow prev" onClick={onClick}>
            <FaArrowLeftLong />
        </button>
    );
};

const EventDetails = () => {

    const { t } = useTranslation();

    const { BaseUrl, MapKey, setIsLoginShow } = useContext(MyContext);
    const currency = getSiteCurrency();

    const [loading, setLoading] = useState(true);
    const [eventData, setEventData] = useState();
    const [eventArtist, setEventArtist] = useState([]);
    const [eventFacility, setEventFacility] = useState([]);
    const [eventRestriction, setEventRestriction] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [isFavorite, setIsFavorite] = useState("");
    const [attendeesList, setAttendeesList] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [selectVideo, setSelectVideo] = useState();
    const [showTicketBox, setShowTicketBox] = useState(false);
    const [ticketList, setTicketList] = useState([]);
    const [totalPrice, setTotalPrice] = useState("0");
    const [selectTicket, setSelectTicket] = useState("");
    const [showChat, setShowChat] = useState(false);
    const [showlightbox, setShowLightBox] = useState(false);
    const [showlightbox2, setShowLightBox2] = useState(false);
    const [lightboxindex, setLightBoxIndex] = useState("");
    const [reviewdata, setReviewData] = useState([]);

    const Navigate = useNavigate();

    const Location = useLocation();
    const ButHidden = Location.state;

    const eventId = sessionStorage.getItem("Eventid");
    const Userid = localStorage.getItem("Userid");

    const zIndex = [40, 30, 20, 10, 0];

    const { event_cover_img, event_img, member_list, total_ticket, total_book_ticket } = eventData || '';

    let newdata = [];
    if (Array.isArray(event_cover_img)) {
        newdata = [event_img, ...event_cover_img];
    } else {
        newdata = [event_img];
    }

    const SportLeft = total_ticket - total_book_ticket;
    const firstFiveImages = member_list?.slice(0, 5);
    const remainingCount = member_list?.length - 5;

    const SlideShow = newdata.length > 4 ? 4 : newdata.length;

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: SlideShow,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1205, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 995, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
        ],
    };

    const gallerysettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1205, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 995, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
        ],
    };

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: MapKey
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        handleHome();
        HandleGetTicket();
        axios.post(
            `${BaseUrl}user_api/joined_user.php`,
            { event_id: eventId },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => {
                // console.log(res);
                setAttendeesList(res?.data?.JoinedUserdata);
            })
            .catch((err) => {
                console.error('Error:', err.message);
            });
    }, [eventId]);

    const handleHome = () => {
        const Userid = localStorage.getItem("Userid") || "0";
        if (Userid && eventId) {
            axios.post(
                `${BaseUrl}user_api/u_event_data.php`,
                {
                    uid: Userid,
                    event_id: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((res) => {
                    console.log(res);
                    if (res?.data?.ResponseCode === '200') {
                        setEventData(res.data.EventData);
                        setIsFavorite(res.data.EventData.IS_BOOKMARK)
                        setEventArtist(res.data.Event_Artist);
                        setEventFacility(res.data.Event_Facility);
                        setEventRestriction(res.data.Event_Restriction);
                        setGallery(res.data.Event_gallery);
                        setReviewData(res.data.reviewdata);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        }
    }

    const HandleGetTicket = () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${BaseUrl}user_api/u_event_type_price.php`, { uid: Userid, event_id: eventId })
                .then((res) => {
                    // console.log("u_event_type_price", res);

                    const TicketData = res.data.EventTypePrice;

                    const TicketFilter = TicketData.map(ticket => ({
                        ...ticket,
                        total: 0,
                        con: 0
                    }));
                    setTicketList(TicketFilter);
                })
                .catch((error) => {
                    console.error("u_event_type_price", error);
                })
        }
    }

    const handleMap = () => {
        const googleMapsUrl = `https://www.google.com/maps?q=${eventData?.event_latitude},${eventData?.event_longtitude}`;
        window.open(googleMapsUrl, '_blank');
    };

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [loading]);

    const getThumbnailUrl = (url) => {
        const videoId = url.split("/").pop();
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    };

    const handleFavorite = (eventId) => {

        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_fav.php`,
                {
                    uid: Userid,
                    eid: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    // console.log(res);
                    if (res?.data?.ResponseCode === '200') {
                        setIsFavorite(isFavorite === 0 ? 1 : 0);
                    }
                    const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
                    showTost(res?.data?.ResponseMsg, toastType);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        } else {
            setIsLoginShow(true);
        }
    }

    const HandleAddTicket = (index) => {
        const updatedList = ticketList.map((ticket, i) => {
            if (i === index) {
                const newCon = ticket.con + 1;
                setTotalPrice(newCon * Number(ticket.ticket_price));
                setSelectTicket(index);
                return {
                    ...ticket,
                    con: newCon,
                    total: newCon * Number(ticket.ticket_price),
                };
            } else {
                return { ...ticket, con: 0, total: 0 };
            }
        });
        setTicketList(updatedList);
    };

    const HandleRemoveTicket = (index) => {
        const updatedList = ticketList.map((ticket, i) => {
            if (i === index) {
                const newCon = Math.max(ticket.con - 1, 0);
                setTotalPrice(newCon * Number(ticket.ticket_price));
                return {
                    ...ticket,
                    con: newCon,
                    total: newCon * Number(ticket.ticket_price),
                };
            } else {
                return ticket;
            }
        });

        setTicketList(updatedList);
    };

    const HandlePurchase = () => {
        if (totalPrice === "0") {
            showTost(t("Please select ticket !!"), "error");
            return;
        }

        const Tax = localStorage.getItem("Tax");

        const Data = {
            Eventid: eventData?.event_id,
            Eventimg: BaseUrl + eventData?.event_img,
            Eventtitle: eventData?.event_title,
            Eventdate: eventData?.event_sdate,
            Eventaddress: eventData?.event_address,
            Sponsoreid: eventData?.sponsore_id,
            Typeid: ticketList[selectTicket]?.typeid,
            Type: ticketList[selectTicket]?.ticket_type,
            con: ticketList[selectTicket]?.con,
            Singleprice: ticketList[selectTicket]?.ticket_price,
            plimit: eventData?.total_ticket,
            Totalprice: totalPrice,
            Tax: (totalPrice * Tax) / 100
        }
        sessionStorage.setItem("EventData", JSON.stringify(Data));
        document.body.style.overflow = "auto";
        Navigate("/order-summery");
    }

    const HandleBookNow = () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            setShowTicketBox(true);
        } else {
            setIsLoginShow(true);
        }
    }

    useEffect(() => {
        showChat
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [showChat]);

    useEffect(() => {
        showTicketBox
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [showTicketBox]);

    const HandleNavigate = (id) => {
        Navigate("/organizer-info", { state: id });
    }

    return (
        <div>
            <div className="event_details">

                <div style={{ marginTop: "20px" }} className="section_1">
                    <div className="slider-container">
                        <Slider {...settings}>
                            {event_cover_img ? (
                                newdata?.map((item, index) => (
                                    <div onClick={() => { setShowLightBox(true); setLightBoxIndex(index) }} key={index} className="imagewrap cursor-pointer">
                                        <img style={{ height: "400px", objectFit: "cover" }} src={`${BaseUrl}${item}`} alt={`Event cover ${index}`} />
                                    </div>
                                ))
                            ) : (
                                <div className="imagewrap">
                                    <img src={`${BaseUrl}${event_img}`} alt="Event cover" />
                                </div>
                            )}
                        </Slider>
                    </div>
                </div>

                <div className="event_container">

                    <div className="section_1">
                        <div style={{ justifyContent: "space-between", marginBottom: "10px" }} className="flex_box">
                            <h2 className="title">{eventData?.event_title}</h2>
                            <div onClick={() => handleFavorite(eventData?.event_id)} className="cursor-pointer">
                                {isFavorite === 1
                                    ? <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                        <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                    </svg>
                                    : <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                        <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                    </svg>}
                            </div>
                        </div>

                        <div className="flex_box py-[5px]">
                            <LuCalendar1 className="text-[24px]" />
                            <p>{eventData?.event_sdate}</p>
                        </div>

                        <div className="flex_box py-[5px]">
                            <MdOutlineAccessTime className="text-[24px]" />
                            <p>{eventData?.event_time_day}</p>
                        </div>

                        <div className="flex_box py-[5px]">
                            <HiOutlineLocationMarker className="text-[24px]" />
                            <p onClick={handleMap} style={{ cursor: "pointer" }} className="flex_box">{eventData?.event_address_title} <img alt="map" width="30px" src={mappin} /></p>
                        </div>

                        {firstFiveImages?.length >= 1 && <div className="flex_box py-[5px]">
                            <TbUsers className="text-[24px]" />
                            <div onClick={() => setIsShow(true)} className="flex items-center cursor-pointer">
                                {firstFiveImages?.map((item, index) => (
                                    <img key={index} style={{
                                        zIndex: zIndex[index]
                                    }} src={`${BaseUrl}${item}`} className="w-[30px] h-[30px] -ms-[5px]" alt="aj" />
                                ))}
                                {member_list?.length > 5 && (
                                    <div className="remaind">
                                        <p>+{remainingCount}</p>
                                    </div>
                                )}
                            </div>
                        </div>}

                        <div  className="flex_box py-[5px]">
                            <TbTicket className="text-[24px]" />
                            <p>{t("Ticket Price")} : {formatMoney(eventData?.ticket_price, currency)}</p>
                        </div>

                        <div className="py-[10px]">
                            <p className="text-red-500 font-bold">{SportLeft} {t("spots left")}</p>
                        </div>

                    </div>

                    <div className="section_2">
                        <div className="">
                            <h className="font-bold">{t("Organized By")}</h>
                            <div style={{ marginTop: "10px" }} className="flex_box">
                                {eventData?.sponsore_img ? (
                                    <img alt="" className="w-[50px] h-[50px] rounded-[100%] object-cover" src={`${BaseUrl}${eventData?.sponsore_img}`} />
                                ) : (
                                    <img alt="" className="w-[50px] h-[50px] rounded-[100%] object-cover" src={profile} />
                                )}
                                <div onClick={() => HandleNavigate(eventData?.sponsore_id)} className="group cursor-pointer">
                                    <h4 className="font-[500] group-hover:text-[#0000ffb7]">{eventData?.sponsore_name}</h4>
                                    {eventData?.is_joined === 1 &&
                                        <span className="text-gray-400 font-[500] text-[14px] group-hover:text-[#0000ffb7]">{eventData?.sponsore_mobile}</span>
                                    }
                                </div>
                            </div>
                        </div>

                        {firstFiveImages?.length >= 1 && <div className="">
                            <h4 className="font-bold">{t("Attendees")}({total_book_ticket})</h4>
                            <div onClick={() => setIsShow(true)} className="flex items-center cursor-pointer mt-[10px]">
                                {firstFiveImages?.map((item, index) => (
                                    <img key={index} style={{
                                        zIndex: zIndex[index]
                                    }} src={`${BaseUrl}${item}`} className="w-[30px] h-[30px] -ms-[5px]" alt="aj" />
                                ))}
                                {member_list?.length > 5 && (
                                    <div className="remaind">
                                        <p>+{remainingCount}</p>
                                    </div>
                                )}
                            </div>
                        </div>}

                        {(Userid && eventData?.is_joined === 1) && <div className="">
                            <h4 className="font-bold">{t("Chat")}</h4>
                            <img onClick={() => setShowChat(true)} className="mt-[10px] cursor-pointer" alt="msg" src={chaticon}></img>
                        </div>}

                    </div>

                    {eventData?.event_about && <div className="section_3">
                        <h1 className="title">{t("About Event")}</h1>
                        <p style={{ marginTop: "10px" }} dangerouslySetInnerHTML={{ __html: eventData?.event_about }} />

                    </div>}

                    {eventData?.event_disclaimer && <div className="section_3">
                        <h1 className="title">{t("Disclaimer")}</h1>
                        <p style={{ marginTop: "10px" }} dangerouslySetInnerHTML={{ __html: eventData?.event_disclaimer }} />
                    </div>}

                    {eventArtist.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Artist")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {eventArtist.map((item, index) => {
                                return <div key={index} className="artist_box">
                                    <img src={BaseUrl + item.artist_img} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.artist_title}</span>
                                    <span style={{ fontSize: "14px", color: "gray" }}>{item.artist_role}</span>
                                </div>
                            })}
                        </div>
                    </div>}

                    {eventFacility.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Facillity")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {eventFacility.map((item, index) => {
                                return <div key={index} className="artist_box">
                                    <img src={BaseUrl + item.facility_img} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.facility_title}</span>
                                </div>
                            })}
                        </div>
                    </div>}

                    {eventRestriction.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Event Prohibited")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {eventRestriction.map((item, index) => {
                                return <div key={index} className="artist_box">
                                    <img src={BaseUrl + item.restriction_img} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.restriction_title}</span>
                                </div>
                            })}
                        </div>
                    </div>}

                    {gallery.length >= 1 && <div className="section_5">
                        <div className="flex_box">
                            <div className="">
                                <div className="expolor_btn">{t("Explore")}</div>
                                <h1 className="title">{t("Gllery")}</h1>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px" }} className="slider-container">
                            <Slider {...gallerysettings}>
                                {gallery.map((item, index) => {
                                    return <div onClick={() => { setShowLightBox2(true); setLightBoxIndex(index) }} key={index} className="">
                                        <img src={BaseUrl + item} className="w-[100%] h-[200px] rounded-[15px] object-cover cursor-pointer" alt="" />
                                    </div>
                                })}
                            </Slider>
                        </div>
                    </div>}

                    {eventData?.event_video_urls.length >= 1 && <div className="section_5">
                        <div className="flex_box">
                            <div className="">
                                <div className="expolor_btn">{t("Explore")}</div>
                                <h1 className="title">{t("Video")}</h1>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px" }} className="slider-container">
                            <Slider {...gallerysettings}>
                                {eventData?.event_video_urls.map((item, index) => {
                                    return <div onClick={() => setSelectVideo(item.split("/").pop())} key={index} style={{ cursor: "pointer" }} className="video_box">
                                        <img src={getThumbnailUrl(item)} className="w-[100%] h-[200px] rounded-[15px] object-cover cursor-pointer" alt="" />
                                        <div className="icon"><FaPlay style={{ marginLeft: "3px" }} /></div>
                                    </div>
                                })}
                            </Slider>
                        </div>
                    </div>}

                    <div className="section_6">
                        {isLoaded &&
                            <GoogleMap
                                center={{ lat: Number(eventData?.event_latitude), lng: Number(eventData?.event_longtitude) }}
                                zoom={17}
                            >
                                <Marker
                                    position={{
                                        lat: Number(eventData?.event_latitude),
                                        lng: Number(eventData?.event_longtitude),
                                    }}
                                    icon={{
                                        url: mapicon,
                                        scaledSize: new window.google.maps.Size(40, 40),
                                    }}
                                />
                            </GoogleMap>
                        }
                    </div>

                    {eventData?.event_tags.length >= 1 && <div className="section_7">
                        <h1 className="title">{t("Tags")}</h1>
                        <div style={{ marginTop: "10px", flexWrap: 'wrap' }} className="flex_box">
                            {eventData?.event_tags.map((item: string, index: number) => (
                                <div key={index} className="">
                                    <span>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>}

                    {reviewdata.length >= 1 && <div className="section_7">
                        <h1 className="title">{t("Reviews")}</h1>
                        <div className="mt-[10px]">
                            {reviewdata.map((item, index) => {
                                return <div key={index} className="flex items-start justify-between border-[2px] p-[10px] rounded-[15px] mt-[10px]">
                                    <div className="flex items-start gap-[10px]">
                                        <img src={BaseUrl + item.user_img} className="w-[55px] h-[55px] border-[2px] rounded-[50px] object-cover" alt="" />
                                        <div className="">
                                            <h1 className="font-bold text-[18px]">{item.customername}</h1>
                                            <p className="text-gray-500">{item.rate_text}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-[5px]">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFA500" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.0328 3.27141C10.8375 1.5762 13.1625 1.57619 13.9672 3.27141L15.3579 6.20118C15.6774 6.87435 16.2951 7.34094 17.0096 7.44888L20.1193 7.91869C21.9187 8.19053 22.6371 10.4895 21.3351 11.8091L19.0849 14.0896C18.5679 14.6136 18.332 15.3685 18.454 16.1084L18.9852 19.3285C19.2926 21.1918 17.4116 22.6126 15.8022 21.7329L13.0208 20.2126C12.3817 19.8633 11.6183 19.8633 10.9792 20.2126L8.19776 21.7329C6.58839 22.6126 4.70742 21.1918 5.01479 19.3286L5.54599 16.1084C5.66804 15.3685 5.43211 14.6136 4.91508 14.0896L2.66488 11.8091C1.36287 10.4895 2.08133 8.19053 3.88066 7.91869L6.99037 7.44888C7.70489 7.34094 8.32257 6.87435 8.64211 6.20118L10.0328 3.27141Z" stroke="#FFA500" stroke-width="1.5" stroke-linejoin="round" />
                                        </svg>
                                        <p>{item.rate_number}</p>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>}
                </div>

                {isShow && <div onClick={() => setIsShow(false)} style={{ alignItems: "end" }} className="bottom_model">
                    <div onClick={(e) => e.stopPropagation()} className="bottom_box">
                        <div className="attendees">
                            <span>{t("Attendees")}</span>
                            <div style={{ height: "500px" }} className="scroll-container">
                                {attendeesList.map((item, index) => (
                                    <div key={index} className="attendees_box">
                                        <img src={BaseUrl + item['user_img']} alt="" />
                                        <div style={{ lineHeight: "20px" }}>
                                            <p>{item['customername']}</p>
                                            <p>{item['Total_ticket_purchase']}x {item['Total_type']}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>}

                {selectVideo && (
                    <div onClick={() => setSelectVideo(undefined)} style={{ alignItems: "center" }} className="bottom_model">
                        <div onClick={(e) => e.stopPropagation()} className="video_box">
                            <iframe
                                width="100%"
                                height="100%"
                                src={`https://www.youtube.com/embed/${selectVideo}`}
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                )}
            </div>

            {showTicketBox && <div onClick={() => setShowTicketBox(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="ticket_bottom">
                    <h1 className="pt-[15px] pb-[10px] font-bold text-[18px]">{t("Ticket Details")}</h1>
                    <div className="border-t-[1px] pb-[10px] border-black"></div>
                    <div className="">
                        <h1 className="font-bold">{t("WHAT TICKET WOULD YOU LIKE?")}</h1>
                        <div className="h-[360px] scroll-container">
                            {ticketList.map((item, index) => {
                                return <div key={index} className="ticket_box">
                                    <div className={`box ${item.con !== 0 && "select_ticket"}`}>{item.con}</div>
                                    <div className="py-[5px] w-[85%] px-[10px]">
                                        <div className="flex items-center justify-between">
                                            <h1 className="font-[500] text-[16px]">{item.ticket_type}</h1>
                                            <button onClick={() => HandleAddTicket(index)} className="text-[22px]"><GoPlus /></button>
                                        </div>
                                        <p className="text-[14px]">{item.description}</p>
                                        <span className="text-[14px] text-[red]">{item.remainTicket} {t("spots left")}</span> <br />
                                        <div className="flex items-center justify-between">
                                            <span className="text-[14px] font-[500] text-gray-600">x {formatMoney(item.ticket_price, currency)} = {formatMoney(item.total, currency)}</span>
                                            <button onClick={() => HandleRemoveTicket(index)} className="text-[25px]"><IoIosRemove /></button>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <button onClick={HandlePurchase} className="button">{t("PURCHASE")} - {formatMoney(totalPrice, currency)}</button>
                </div>
            </div>}

            {loading && <Loading />}

            {(ButHidden !== "Past" && SportLeft !== 0) && <div className="fixed left-0 right-0 bottom-0 bg-white py-[10px] z-[888]">
                <div className="w-[40%] mx-auto max-_430_:w-[90%] max-_770_:w-[70%]">
                    <button onClick={HandleBookNow} style={{ marginTop: "0" }} className="button">{t("Book Now")}</button>
                </div>
            </div>}

            {showChat && <div onClick={() => setShowChat(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="chat_bottom">
                    <Chat index={0} name={eventData?.sponsore_name} id={eventData?.sponsore_id} setShowChat={setShowChat} />
                </div>
            </div>}

            {showlightbox && <LightboxImg Images={newdata} setOpen={setShowLightBox} open={showlightbox} index={lightboxindex} />}
            {showlightbox2 && <LightboxImg Images={gallery} setOpen={setShowLightBox2} open={showlightbox2} index={lightboxindex} />}

        </div>
    )
}

export default EventDetails
/* jshint ignore:end */
